import type { AppError } from '../types';

/**
 * Fallback normalizer for errors that don't match any known shape.
 * Always returns an AppError — this is the last normalizer in the chain.
 */
export function normalizeUnknownError(error: unknown): AppError {
  if (error instanceof Error) {
    return {
      code: 'UNKNOWN_ERROR',
      message: error.message,
      category: 'system',
      originalError: error,
    };
  }

  if (typeof error === 'string') {
    return {
      code: 'UNKNOWN_ERROR',
      message: error,
      category: 'system',
      originalError: error,
    };
  }

  return {
    code: 'UNKNOWN_ERROR',
    message: 'An unexpected error occurred. Please try again later.',
    category: 'system',
    originalError: error,
  };
}
